/**
 * Derive Vendor Tag → Accounting mapping list from GET /tag-mappings response.
 */
import {
  extractTagMappingsArray,
  normalizeTagMappingRow,
} from "../../../utils/tagMappingApiNormalize";

const VENDOR = "VENDOR_TO_ACCOUNTING";

export function getVendorTagMappingsListFromApiData(data) {
  const rows = extractTagMappingsArray(data?.data ?? data);
  return rows.map((r) => normalizeTagMappingRow(r, VENDOR)).filter(Boolean);
}

export function getVendorTagMappingsMetaFromApiData(data) {
  return data?.data?.meta ?? data?.meta ?? null;
}
